import BaseService from "../../BaseService";

export default class BenutzerService extends BaseService {

  constructor(prefix, id) {
    super(`${prefix}/${id}/benutzer`);
  }

  async findByEmail(email) {
    await this.retrieveBackendUrl()
    return this.checkError(
      fetch(`${this.backendUrl}?email=${email}`, {
        method: 'GET',
        cache: 'reload',
        headers: this.getJsonHeader()
      })
    )
  }

}
